import { render } from "./Column202311.vue?vue&type=template&id=2a540f32&scoped=true"
import script from "./Column202311.vue?vue&type=script&lang=js"
export * from "./Column202311.vue?vue&type=script&lang=js"

import "./Column202311.vue?vue&type=style&index=0&id=2a540f32&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a540f32"

export default script